/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Edit_Tracking_Number_PlaceholderInputs */

const en_samples_edit_tracking_number_placeholder = /** @type {(inputs: Samples_Edit_Tracking_Number_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking number`)
};

const es_samples_edit_tracking_number_placeholder = /** @type {(inputs: Samples_Edit_Tracking_Number_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero de rastreo`)
};

/**
* | output |
* | --- |
* | "Tracking number" |
*
* @param {Samples_Edit_Tracking_Number_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_edit_tracking_number_placeholder = /** @type {((inputs?: Samples_Edit_Tracking_Number_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Edit_Tracking_Number_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_edit_tracking_number_placeholder(inputs)
	return es_samples_edit_tracking_number_placeholder(inputs)
});